export function popStateListener(): void {
  history.pushState(null, null, window.location.href);
}
